export { default } from "~/components/product/BuyTogether"
export { default as LoadingFallback } from "~/components/LoadingFallback"

// O editor marcou esta section ⚡ (wrapper `Lazy` no bloco da PDP), mas ela cai
// no índice 5 — dentro do `foldThreshold: 6` de setup.ts — e o site roda com
// `respectCmsLazy: false`, então acabava eager: mais uma busca VTEX
// below-the-fold segurando o primeiro byte. Ver issue #180.
export const deferred = true
